import { render, staticRenderFns } from "./ObkDescriptionNoAdBlockerStep.vue?vue&type=template&id=32b99959&scoped=true"
import script from "./ObkDescriptionNoAdBlockerStep.vue?vue&type=script&lang=js"
export * from "./ObkDescriptionNoAdBlockerStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b99959",
  null
  
)

export default component.exports